import React from "react"
import logo from '../../loading.gif';


export default function Loading({ open }) {
    return (
        <>
            {open &&
                <div className="styleLoading">
                    <img src="loading.gif"/>
                </div>

            }
        </>
    )
}

